/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontProductTile_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ItemHeartWrapper_viewer">;
    readonly " $refType": "StorefrontProductTile_viewer";
};
export type StorefrontProductTile_viewer$data = StorefrontProductTile_viewer;
export type StorefrontProductTile_viewer$key = {
    readonly " $data"?: StorefrontProductTile_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontProductTile_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontProductTile_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ItemHeartWrapper_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "hasUserId"
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds"
        }
      ]
    }
  ]
};
(node as any).hash = 'dc02e0f25895beaf6d94f824ca0cba43';
export default node;
